/**
 * Postavke instance (firme) – u build vrijeme iz firms/<id>/firm.json + secrets.env.
 * Fallback vrijednosti = dotadašnji Stefmark nazivi ako nema REACT_APP_*.
 */

export const appConfig = {
  firmId: process.env.REACT_APP_FIRM_ID || 'default',
  appTitle: process.env.REACT_APP_APP_TITLE || 'Stefmark SATI',
  shortName: process.env.REACT_APP_APP_SHORT_NAME || 'StefmarkSATI',
  metaDescription:
    process.env.REACT_APP_META_DESCRIPTION ||
    'Stefmark SATI – aplikacija za obračun i metrike',
  themeColor: process.env.REACT_APP_THEME_COLOR || '#b22222',
  navbarBrand:
    process.env.REACT_APP_NAVBAR_BRAND ||
    process.env.REACT_APP_APP_TITLE ||
    'Stefmark SATI',
};
